import React, { useEffect, useRef, useState } from "react";
import "../../Style/CounterSection.css";
import { myCustomTheme } from "../../Theme";

const counterData = [
  { number: 2, suffix: "Th", title: "Years of Excellence" },
  { number: 200, suffix: "+", title: "Projects Delivered" },
  { number: 100, suffix: "+", title: "Materials Available" },
  { number: 80, suffix: "+", title: "Happy Clients" },
];

const CounterCard = ({ number, suffix, title }) => {
  const [count, setCount] = useState(0);
  const [startCount, setStartCount] = useState(false);
  const [visible, setVisible] = useState(false);

  const counterRef = useRef(null);

  useEffect(() => {
    const node = counterRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCount(true);
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!startCount) return;

    let start = 0;
    const duration = 2000;
    const increment = number / (duration / 16);

    const timer = setInterval(() => {
      start += increment;

      if (start >= number) {
        setCount(number);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [startCount, number]);

  return (
    <div
      className={`counter-card ${visible ? "show" : ""}`}
      ref={counterRef}
    >
      <h2
        className="counter-number"
        style={{
          color: myCustomTheme.colors.heading,
          fontFamily: myCustomTheme.typography.heading_font,
        }}
      >
        {count.toLocaleString()}
        <span className="counter-suffix" style={{ color: "#ff9f1c" }}>
          {suffix}
        </span>
      </h2>

      <p
        className="counter-title"
        style={{
          color: myCustomTheme.colors.menu_text,
          fontFamily: myCustomTheme.typography.text_font,
        }}
      >
        {title}
      </p>
    </div>
  );
};

const CounterSection = () => {
  // ✅ section open animation
  useEffect(() => {
    const section = document.querySelector(".counter-section");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section
      className="counter-section"
      style={{
        background: myCustomTheme.colors.bg_primary,
        "--theme-shadow": myCustomTheme.shadows.neumorphic,
        fontFamily: myCustomTheme.typography.text_font,
      }}
    >
      <div className="counter-main-box">
        {counterData.map((item, index) => (
          <CounterCard key={index} {...item} />
        ))}
      </div>
    </section>
  );
};

export default CounterSection;